/**
 * The words that open a TABLE-level constraint inside a column list, rather
 * than naming a column.
 *
 * `CREATE TABLE t (id INT, PRIMARY ▮)` looks exactly like a column definition
 * to a "previous token is an identifier" data-type recognizer — these words are
 * not reserved in every engine's tokenizer, so they arrive as plain
 * identifiers and the type vocabulary answered a position whose only legal
 * continuation is `KEY`. Mirrors the clause-token guard in
 * `editorContextSlotShared.ts`.
 */
const CONSTRAINT_LEAD_WORDS: ReadonlySet<string> = new Set([
  'PRIMARY', 'UNIQUE', 'FOREIGN', 'CONSTRAINT', 'CHECK', 'EXCLUDE', 'FULLTEXT',
  'SPATIAL', 'INDEX', 'KEY', 'PERIOD',
]);

export function isConstraintLeadWord(word: string): boolean {
  return CONSTRAINT_LEAD_WORDS.has(word.toUpperCase());
}
